import React from 'react';
import { connect } from 'dva';

import {component_tool,framework_tool} from '../../../tool'
let {WizButton} = component_tool;
let { WizContainer } = framework_tool;

class Dynamic extends WizContainer {

  componentName = 'Dynamic';

  constructor(props) {
    super(props);
    this.buildActionKey();
    this.state = {
    }
  }


  _onError() {
    我是错误
  }

  render() {
    return (
      <div>
        <p>点击事件记录：</p><br />
        <div title="wizRecordTitle1" data-wiz-log key={'_record'} style={{ height: 100, width: 200, background: 'skyblue' }}>
          <p style={{ height: 50, width: 100, background: 'red', color: 'white' }} data-wiz-log>
            点红色和点蓝色是不一样的哦
          </p>
        </div>
        <p>错误日志：</p>
        <WizButton
          size="large"
          type="primary"
          onClick={() => { this._onError().catch(() => { }) }}
        >
          error
        </WizButton>
        <p>读取日志记录：</p>
        <WizButton
          size="large"
          type="primary"
          onClick={() => { log.info('log:', storage._getStorageInfo()) }}
        >
          log storage
        </WizButton>
        <br />
        <p>移除用户日志：</p>
        <WizButton
          size="large"
          type="primary"
          onClick={() => { storage.removeStorage(constants.env.app_user_log_key) }}
        >
          remove storage
        </WizButton>
        <br />
        <p>清除所有日志：</p>
        <WizButton
          size="large"
          type="primary"
          onClick={() => { storage._clearStorage() }}
        >
          clear storage
        </WizButton>
        <br />
      </div>
    )
  }
}

const mapStateToProps = (state, ownProps) => {
  return {

  };
};

export default connect(mapStateToProps)(Dynamic);
